import { PrizeText } from "@/components/prize-text";
import { cn } from "@/lib/utils";

export type JackpotCardSize = "large" | "compact";

/**
 * The pot — the one number this campaign type exists to show, and deliberately a dumb component:
 * it takes the server-rendered `display` string (already in the viewer's currency and language,
 * so it is never re-formatted here) and a card size, and knows nothing about time, state or the
 * stream.
 *
 * It is `PrizeText` at `hero` (the large card) or `large` (the compact card), and the one place
 * in the dashboard that asks it to `animate` — the digits ride the reels, the number flares as it
 * lands. A finished campaign's frozen figure is `muted`: flat, still, no depth. Tabular figures so
 * a changing pot never shifts the glyphs beside it.
 */
export const JackpotPot = ({
  display,
  size,
  muted = false,
  className,
}: {
  display: string;
  size: JackpotCardSize;
  muted?: boolean;
  className?: string;
}) => (
  <PrizeText
    size={size === "large" ? "hero" : "large"}
    tone={muted ? "muted" : "gold"}
    animate={!muted}
    // Never clipped: a pot wider than its card (a long amount in the overlay's narrow column)
    // shrinks to fit. An amount can't wrap, and its reels can't glide, so the floor sits lower
    // than a prize title's.
    fit="marquee"
    minScale={0.5}
    className={cn("block tabular-nums", className)}
  >
    {display}
  </PrizeText>
);
